"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSelectedProductRegistry = exports.getSelectedProductDetails = exports.getSelectedProduct = exports.getRegistryLoadingPromise = exports.getRegistryData = exports.getProductsRegistryMap = exports.getProductsRegistry = exports.getProductsOrder = exports.getProductsByTypes = exports.getProducts = exports.getProductSortedIndex = exports.getProductRegistryErrors = exports.getProductRegistryById = exports.getProductLocale = exports.getProductId = exports.getProductDetailsErrors = exports.getProductDetailsById = exports.getProductAccountKey = exports.getProduct = exports.getOrigin = exports.getOrderTypes = exports.getLoadingPromises = exports.getIsRegistryLoaded = exports.getIsLoading = exports.getIsLoaded = exports.getInjectedCardDetails = exports.getHasError = exports.getFilteredTypes = exports.getFilterTypes = exports.getError = exports.getDefaultTypes = exports.getData = exports.getCustomerProductMarkets = exports.getAccountTokenByAccountKey = void 0;
var _reselect = require("reselect");
var _config = _interopRequireDefault(require("./config"));
var _constants = require("./constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/**
 *  Helpers
 */
const getProductsState = state => _config.default.getToState(state);
const getProductIdFromProps = function (state) {
  let ownProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return ownProps.productId;
};
const getFilterTypes = () => {
  if (_config.default.filterTypes.length > 0) {
    return _config.default.filterTypes;
  }
  return _constants.allTypes;
};
exports.getFilterTypes = getFilterTypes;
const getDefaultTypes = () => {
  if (_config.default.defaultTypes.length > 0) {
    return _config.default.defaultTypes;
  }
  return _constants.allTypes;
};
exports.getDefaultTypes = getDefaultTypes;
const getOrderTypes = () => {
  if (_config.default.orderTypes.length > 0) {
    return _config.default.orderTypes;
  }
  return _constants.allTypes;
};
exports.getOrderTypes = getOrderTypes;
const getCustomerProductMarkets = () => _config.default.customerProductMarkets;
exports.getCustomerProductMarkets = getCustomerProductMarkets;
const getFilteredTypes = function () {
  let types = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultTypes();
  const filterTypes = getFilterTypes();
  return types.filter(type => filterTypes.includes(type));
};
exports.getFilteredTypes = getFilteredTypes;
const getProductsRegistry = function (state) {
  let types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getFilterTypes();
  const filteredTypes = getFilteredTypes(types);
  const productsState = getProductsState(state);
  return filteredTypes.filter(type => productsState.hasIn(['registry', 'types', type])).reduce((accum, type) => ({
    ...accum,
    [type]: productsState.getIn(['registry', 'types', type])
  }), {});
};
exports.getProductsRegistry = getProductsRegistry;
const getProductsRegistryMap = (0, _reselect.createSelector)([getProductsRegistry], registryByTypes => {
  const registryListToMap = list => list.reduce((accum, _ref) => {
    let {
      opaqueAccountId,
      ...productData
    } = _ref;
    return {
      ...accum,
      [opaqueAccountId]: {
        opaqueAccountId,
        ...productData
      }
    };
  }, {});

  // build single map of all loaded types
  return Object.keys(registryByTypes).reduce((accum, type) => ({
    ...accum,
    ...registryListToMap(registryByTypes[type])
  }), {});
});
exports.getProductsRegistryMap = getProductsRegistryMap;
const getProductRegistryById = (state, identifer) => {
  const registryMap = getProductsRegistryMap(state);
  return registryMap[identifer];
};
exports.getProductRegistryById = getProductRegistryById;
const getProductRegistryErrors = (0, _reselect.createSelector)([getProductsState], state => ({
  cardError: state.getIn(['registry', 'cardError']),
  customerError: state.getIn(['registry', 'customerError'])
}));
exports.getProductRegistryErrors = getProductRegistryErrors;
const getProductsByTypes = function (state) {
  let types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getFilterTypes();
  const productsState = getProductsState(state);
  const filteredTypes = getFilteredTypes(types);
  return filteredTypes.filter(type => productsState.hasIn(['details', 'types', type])).reduce((accum, type) => ({
    ...accum,
    [type]: productsState.getIn(['details', 'types', type])
  }), {});
};
exports.getProductsByTypes = getProductsByTypes;
const getProductDetailsErrors = function (state) {
  let types = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getFilterTypes();
  const productsState = getProductsState(state);
  const filteredTypes = getFilteredTypes(types);
  return filteredTypes.filter(type => productsState.hasIn(['details', 'errors', type])).reduce((accum, type) => ({
    ...accum,
    [type]: productsState.getIn(['details', 'errors', type])
  }), {});
};
exports.getProductDetailsErrors = getProductDetailsErrors;
const getProductDetailsById = (state, identifier) => {
  const productsByTypes = getProductsByTypes(state);

  // build single map of all loaded types
  const allProductsList = Object.keys(productsByTypes).reduce((accum, type) => ({
    ...accum,
    ...productsByTypes[type].productsList
  }), {});
  return allProductsList[identifier];
};
exports.getProductDetailsById = getProductDetailsById;
const getAccountTokenByAccountKey = (state, key) => {
  const productsByTypes = getProductsByTypes(state);

  // build single map of all loaded types
  const allProductsList = Object.keys(productsByTypes).reduce((accum, type) => ({
    ...accum,
    ...productsByTypes[type].productsList
  }), {});

  // search for matching account key
  const {
    // member
    account_token: memberToken,
    // one-data
    accountToken = memberToken
  } = Object.values(allProductsList).find(_ref2 => {
    let {
      // member
      account_key: memberKey,
      // one-data
      accountKey = memberKey
    } = _ref2;
    return accountKey === key;
  }) || {};
  return accountToken;
};

/**
 *  Internal
 */
exports.getAccountTokenByAccountKey = getAccountTokenByAccountKey;
const getRegistryLoadingPromise = (0, _reselect.createSelector)([getProductsState], state => state.getIn(['registry', 'loading']));
exports.getRegistryLoadingPromise = getRegistryLoadingPromise;
const getIsRegistryLoaded = (0, _reselect.createSelector)([getProductsState], state => state.getIn(['registry', 'loaded']));
exports.getIsRegistryLoaded = getIsRegistryLoaded;
const getRegistryData = state => {
  const productsState = getProductsState(state);
  return {
    selectedProduct: productsState.get('selectedProduct'),
    ...getProductsRegistry(state)
  };
};
exports.getRegistryData = getRegistryData;
const getLoadingPromises = (state, types) => {
  const productsState = getProductsState(state);
  const filteredTypes = getFilteredTypes(types);
  return filteredTypes.filter(type => productsState.hasIn(['details', 'loading', type])).reduce((accum, type) => [...accum, productsState.getIn(['details', 'loading', type])], []);
};
exports.getLoadingPromises = getLoadingPromises;
const getIsLoading = (state, types) => {
  const filteredTypes = getFilteredTypes(types);
  const loadingPromises = getLoadingPromises(state, filteredTypes);
  return loadingPromises.length > 0 && loadingPromises.length === filteredTypes.length;
};
exports.getIsLoading = getIsLoading;
const getHasError = (state, types, permitPartialLoad) => {
  const productDetailsErrors = getProductDetailsErrors(state, types);
  const registryByTypes = getProductsRegistry(state, types);
  const existingTypes = Object.keys(registryByTypes).filter(type => type !== _constants.CARD_PRODUCT && registryByTypes[type] && registryByTypes[type].length > 0);

  // only get errors by types that are requested
  // card products are always requested
  const requestedTypes = [_constants.CARD_PRODUCT, ...existingTypes];
  return permitPartialLoad ? requestedTypes.every(type => !!productDetailsErrors[type]) : requestedTypes.some(type => !!productDetailsErrors[type]);
};
exports.getHasError = getHasError;
const getErrors = (state, types) => Object.values(getProductDetailsErrors(state, types));
const getError = (state, types) => getErrors(state, types).find(value => value instanceof Error);
exports.getError = getError;
const getData = (state, types) => {
  const productsState = getProductsState(state);
  return {
    selectedProduct: productsState.get('selectedProduct'),
    ...getProductsByTypes(state, types)
  };
};
exports.getData = getData;
const getIsLoaded = (state, types) => {
  const productsByTypes = getProductsByTypes(state, types);
  const errorsByTypes = getProductDetailsErrors(state, types);
  const filteredTypes = getFilteredTypes(types);
  const loadedTypes = Object.keys(productsByTypes);
  const erroredTypes = Object.keys(errorsByTypes);
  return filteredTypes.every(key => loadedTypes.includes(key) || erroredTypes.includes(key));
};
exports.getIsLoaded = getIsLoaded;
const getProductLocale = (state, accountToken) => {
  // mismash of both product type structures
  const {
    // shared
    profile: {
      // member
      locale_preference: memberLocale,
      // one-data
      localePreference: locale = memberLocale
    } = {}
  } = getProductDetailsById(state, accountToken) || {};
  return locale;
};
exports.getProductLocale = getProductLocale;
const getInjectedCardDetails = (0, _reselect.createSelector)([getProductsState], productsState => productsState.get('injectedCardDetails'));

/**
 *  External
 */
exports.getInjectedCardDetails = getInjectedCardDetails;
const getSelectedProduct = (0, _reselect.createSelector)([getProductsState], productsState => productsState.get('selectedProduct'));
exports.getSelectedProduct = getSelectedProduct;
const getSelectedProductRegistry = (0, _reselect.createSelector)([getProductsState, getSelectedProduct], (state, selectedProduct) => getProductRegistryById(state, selectedProduct));
exports.getSelectedProductRegistry = getSelectedProductRegistry;
const getSelectedProductDetails = (0, _reselect.createSelector)([getProductsState, getSelectedProduct], (state, selectedProduct) => getProductDetailsById(state, selectedProduct));
exports.getSelectedProductDetails = getSelectedProductDetails;
const getProducts = state => {
  console.warn('\'getProducts\' is deprecated in favor of \'getProductsByTypes\'.');
  const productsByTypes = getProductsByTypes(state, getDefaultTypes());
  const orderTypes = getOrderTypes(state);
  return orderTypes.filter(type => !!productsByTypes[type]).reduce((accum, type) => ({
    ...accum,
    ...productsByTypes[type].productsList
  }), {});
};
exports.getProducts = getProducts;
const getProductsOrder = state => {
  console.warn('\'getProductsOrder\' is deprecated in favor of \'getProductsByTypes\'.');
  const productsByTypes = getProductsByTypes(state, getDefaultTypes());
  const orderTypes = getOrderTypes(state);
  return orderTypes.filter(type => !!productsByTypes[type]).reduce((accum, type) => [...accum, ...productsByTypes[type].productsOrder], []);
};
exports.getProductsOrder = getProductsOrder;
const getProductId = (0, _reselect.createSelector)([getSelectedProduct, getProductIdFromProps], (selectedProductId, ownPropsProductId) => ownPropsProductId || selectedProductId);
exports.getProductId = getProductId;
const getProduct = (state, ownProps) => {
  console.warn('\'getProduct\' is deprecated in favor of \'getProductDetailsById\'.');
  const productId = getProductId(state, ownProps);
  return getProductDetailsById(state, productId);
};
exports.getProduct = getProduct;
const getProductSortedIndex = (0, _reselect.createSelector)([getProduct],
// no translation on one-data products
function () {
  let {
    sorted_index: sortedIndex
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return sortedIndex;
});
exports.getProductSortedIndex = getProductSortedIndex;
const getProductAccountKey = (state, ownProps) => {
  const {
    account_key: accountKey = '0'
  } = getProductDetailsById(state, getProductId(state, ownProps)) || {};
  return accountKey;
};
exports.getProductAccountKey = getProductAccountKey;
const getOrigin = state => state.browser ? state.browser.getIn(['location', 'origin']) // app4
: state.getIn(['browser', 'location', 'origin']) // app5
;
exports.getOrigin = getOrigin;